import { memo, useMemo } from 'react';

import { useFormikContext } from 'formik';

import { useClinicalNoteContext } from 'lib/context/ClinicalNoteContext/ClinicalNoteContext';

import AdvancedNoteComponent from '../components/AdvancedNoteComponent';

const AdvancedForm = ({
  currAdvForm: _currAdvForm = {},
  withStyle = true,
  noteType,
  customCN = null,
  isScrolling,
  setCustomCN = () => {}
}) => {
  const cnContext = useClinicalNoteContext();
  const { values: { isMacro } = {} } = useFormikContext() || {};

  const { customFormTypes, advancedFormRef, setCustomFormTypes } = !isMacro ? cnContext : {};

  const currAdvForm = useMemo(() => {
    const form = customFormTypes?.[noteType]?.find(
      (item) => _currAdvForm?.custom_title === item?.custom_title
    );

    if (form) return form;

    return _currAdvForm;
  }, [_currAdvForm, JSON.stringify(customFormTypes?.[noteType])]);

  return (
    <AdvancedNoteComponent
      noteType={noteType}
      formDataKey="advancedCustomNote"
      advancedNoteRef={advancedFormRef}
      currAdvForm={currAdvForm}
      withStyle={withStyle}
      isMacro={isMacro}
      customCN={customCN}
      isScrolling={isScrolling}
      setAdvancedNote={setCustomFormTypes}
      setCustomCN={setCustomCN}
    />
  );
};

export default memo(AdvancedForm);
